import { Box, Checkbox, FormControl, ListItemText, MenuItem, Select } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core/styles";

// Unified filter pill — matches Queues / Users / Tags. Even though
// this one was already green, the 25% green fill was too loud and
// drew the eye away from the actual content. Toned to neutral
// hairline + brand-green hover so all four filter pills look like
// siblings.
const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  return {
    selectButton: {
      backgroundColor: isDark ? "#131614" : "#fff",
      borderRadius: 10,
      transition: "border-color 0.18s ease, background-color 0.18s ease",
      "&:hover": {
        backgroundColor: isDark
          ? "rgba(46, 227, 122, 0.06)"
          : "rgba(37, 211, 102, 0.06)",
      },
      "& .MuiSelect-outlined": {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 14,
        paddingRight: 32,
        fontSize: 13,
        fontWeight: 600,
        color: isDark ? "#e4e4e7" : "#0f172a",
      },
      "& .MuiSelect-icon": {
        color: isDark ? "#a8acb3" : "#64748b",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderWidth: 1,
        borderColor: isDark
          ? "rgba(255, 255, 255, 0.07)"
          : "#eaeaea",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: isDark
          ? "rgba(46, 227, 122, 0.4)"
          : "#86efac",
      },
    },
  };
});

export function WhatsAppFilter({ onFiltered }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const [whatsAppAccounts, setWhatsAppAccounts] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);

  useEffect(() => {
    loadWhatsAppAccounts();
  }, []);

  const loadWhatsAppAccounts = async () => {
    try {
      const { data } = await api.get(`/whatsapp/`);
      setWhatsAppAccounts(data);
    } catch (err) {
      toastError(err);
    }
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedAccounts(value);
    onFiltered(value);
  };

  return (
    <Box style={{ paddingRight: 5 }}>
      <FormControl fullWidth margin="dense">
        <Select
          className={classes.selectButton}
          multiple
          displayEmpty
          variant="outlined"
          value={selectedAccounts}
          onChange={handleChange}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
          }}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em>{t("connections.title")}</em>;
            }
            return selected.map((id) => 
              whatsAppAccounts.find((account) => account.id === id)?.name
            ).join(", ");
          }}
        >
          {whatsAppAccounts.length > 0 &&
            whatsAppAccounts.map((account) => (
              <MenuItem key={account.id} value={account.id}>
                <Checkbox
                  size="small"
                  checked={selectedAccounts.indexOf(account.id) > -1}
                />
                <ListItemText primary={account.name} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
}